<template>
  <div class="d-flex content-center">
    <c-pagination size="sm" :active-page="this.currentPage" :pages="numPages" @update:activePage="goToPage" />
    <br />
  </div>
</template>

<script>
export default {
  props: {
    numPages: Number,
    currentPage: Number,
    pageList: Array,
  },
  data() {
    return {};
  },
  methods: {
    goToPage(pageNo, e) {
      this.$emit('loadPage', pageNo);
    },
  },
};
</script>

<style lang="scss" scoped=""></style>
